
import { useState, useEffect } from "react";
import { useChannel } from "./use-channel";
import { useChannelMessages } from "./use-channel-messages";
import { useMember } from "./use-member";
import { useTemporaryChannel } from "./use-temporary-channel";
import { supabase } from "@/integrations/supabase/client";
import { safeMaybeSingle } from "@/utils/supabase/queries";
import { isDatabaseRecord, toDatabaseValue } from "@/utils/supabase/type-guards";

export const useChannelChat = (channelId?: string, groupId?: string, userId?: string) => {
  const [group, setGroup] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  
  // Use the hooks with proper string parameters
  const { channel } = useChannel(channelId);
  const { messages } = useChannelMessages(channelId);
  const { member: currentMember } = useMember(groupId, userId);
  const { expiryTime } = useTemporaryChannel(channel);

  useEffect(() => {
    const fetchGroup = async () => {
      if (!groupId) {
        setLoading(false);
        return;
      }

      try {
        const groupData = await safeMaybeSingle<any>(
          supabase
            .from("groups")
            .select("*")
            .eq("id", toDatabaseValue(groupId)),
          "Failed to fetch group"
        );

        if (groupData && isDatabaseRecord(groupData)) {
          setGroup(groupData);
        }
      } catch (error) {
        console.error("Error fetching group:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGroup();
  }, [groupId]);

  return {
    channel,
    group,
    messages,
    currentMember: { member: currentMember, loading: false },
    loading,
    expiryTime
  };
};
